import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import en from "vuetify/es5/locale/en";
import tr from "vuetify/es5/locale/tr";
import { storageManager } from "./storage-manager";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#ff0000",
        secondary: "#424242",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107"
      }
    }
  },
  icons: {
    iconfont: "mdiSvg"
  },
  lang: {
    locales: { tr, en },
    current: storageManager.get("user")
      ? JSON.parse(storageManager.get("user")).language
      : process.env.VUE_APP_I18N_FALLBACK_LOCALE
  }
});
